module.exports = __webpack_public_path__ + "img/page12_text.c8826f39.png";